import React, {Component} from 'react';
import '../css/App.css';
import {Route, BrowserRouter as Router, Switch} from "react-router-dom";
import Admin from "./pages/admin/Admin";
import Site from "./pages/Site";
import 'antd/dist/antd.css';

class App extends Component {

    render() {
        return (
            <Router>
                <Switch>
                    <Route path={"/admin"} render={() => <Admin/>}/>
                    <Route path={"/"} render={() => <Site/>}/>
                </Switch>
            </Router>
        );
    }

}

export default App;
